import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import Axios from '../../config/axios';
import ExhibitorSearch from './ExhibitorSearch';
import QRCode from 'qrcode.react';
import { toast, confirm } from '@rickylandino/react-messages';
import logo from '../../img/D2P-logo-show-login-sm.png';

function NewApiTester(props) {
    const [state, setState] = useState({
        
    });

    useEffect(() => {
        
    }, []);

    //function handleVerifyAPIKey() {
    //    Axios.get(`/api/VerifyAPIKey`, {
    //        params: {
    //            apiKey: 'D2P@16W@t3rburY'
    //        }
    //    }).then(response => {
    //        if (response.data.includes('verified')) {
    //            toast.success(response.data);
    //        }
    //        else {
    //            toast.error(response.data);
    //        }
    //    }).catch(error => {
    //        console.log(error);
    //    });
    //}

    //function handleGetActiveShowsForD2PApp() {
    //    Axios.get(`/api/GetActiveShowsForD2PApp`, {
    //        params: {
    //            apiKey: 'D2P@16W@t3rburY'
    //        }
    //    }).then(response => {
    //        console.log(response.data);

    //        toast.info('Active D2P App Shows returned to console');

    //    }).catch(error => {
    //        console.log(error);
    //    });
    //}

    //function handleGetAppControlInfo() {
    //    Axios.get(`/api/GetAppControlInfo`, {
    //        params: {
    //            apiKey: 'D2P@16W@t3rburY'
    //        }
    //    }).then(response => {
    //        console.log(response.data);

    //        toast.info('D2P App Control Info returned to console');

    //    }).catch(error => {
    //        console.log(error);
    //    });
    //}

    //function handleRegisterExhibitor() {
    //    Axios.get(`/api/RegisterExhibitor`, {
    //        params: {
    //            apiKey: 'D2P@16W@t3rburY',
    //            exhibitorid: 3547,
    //            showcode: 380,
    //            deviceid: 'DNPDVUBN0D84'
    //        }
    //    }).then(response => {
    //        if (response.data.includes('Successful')) {
    //            toast.success(response.data);
    //        }
    //        else if (response.data.includes('Failed')) {
    //            toast.error(response.data);
    //        }
    //        else {
    //            toast.info(response.data);
    //        }
    //    }).catch(error => {
    //        console.log(error);
    //    });
    //}

    //function handleValidateExhibitor() {
    //    Axios.get(`/api/ValidateExhibitor`, {
    //        params: {
    //            apiKey: 'D2P@16W@t3rburY',
    //            exhibitorid: 3547
    //        }
    //    }).then(response => {
    //        if (response.data.includes('Success')) {
    //            toast.success('Exhibitor Validated Successfully');
    //        }
    //        else {
    //            toast.error('Exhibitor Not Found');
    //        }
    //    }).catch(error => {
    //        console.log(error);
    //    });
    //}

    //function handleGetHallImageFileFromDB() {
    //    Axios.get(`/api/GetHallImageFileFromDB`, {
    //        params: {
    //            apiKey: 'D2P@16W@t3rburY',
    //            showcode: 380
    //        }
    //    }).then(response => {
    //        console.log(response.data);

    //        toast.info('Hall Image returned to console');
    //    }).catch(error => {
    //        console.log(error);
    //    });
    //}

    //function handleProcessLeadsToD2P() {
    //    //let myLeads = [
    //    //    { AppLeadID: 100, FName: 'Dave', LName: 'Landino', Company: 'Automated Concepts, LLC', Title: 'Owner', Email: 'dlandino@automated-concepts.com', Phone: '860-965-9916', Address: '42 Madison Way', City: 'South Windsor', State: 'CT', Zip: '06074', PurchasingRole: 'F', Timeframe: 'A', IndustryCode: 'Consultant', LeadGrade: '', Rep: '', FollowUp: '', LeadNotes: 'Testing edit lead using ProcessLeadsToD2P API', DeviceId: 'DNPDVUBN0D84', OriginalScan: '2024-07-30 06:44:01.473' },
    //    //    { AppLeadID: 101, FName: 'Hunter', LName: 'Ashner', Company: 'Automated Concepts, LLC', Title: 'DEV', Email: 'hashner@automated-concepts.com', Phone: '860-921-6542', Address: '81 VANDERPOEL AVE', City: 'Bantam', State: 'CT', Zip: '06750', PurchasingRole: 'S', Timeframe: 'B', IndustryCode: 'Consultant', LeadGrade: '', Rep: '', FollowUp: '', LeadNotes: 'Testing add of 2nd edit lead using ProcessLeadsToD2P API', DeviceId: 'DNPDVUBN0D85', OriginalScan: '2024-07-30 07:26:00.000' }
    //    //];

    //    let myLeads = [{ "AppLeadID": 13, "FName": "Hunter", "LName": "Ashner", "Company": "", "Title": "", "Email": "", "Phone": "", "Address": "", "City": "", "State": "", "Zip": "", "PurchasingRole": "", "Timeframe": "", "IndustryCode": "N/A", "LeadGrade": "N/A", "Rep": "", "FollowUp": "", "LeadNotes": "", "DeviceId": "B72225C1-4286-4161-BC26-C9742FD5A3A9", "OriginalScan": "" }]

    //    //let myLeads = [{ "AppLeadID": 2, "FName": "DENNIS", "LName": "MURPHY", "Company": "CMB USA HV INDUSTRIES", "Title": "PLANT MGR", "Email": "DENNIS.MURPHY@CMBE.COM", "Phone": "215-322-3527", "Address": "3100 TREMONT", "City": "FEASTERVILLE", "State": "PA", "Zip": "18901", "PurchasingRole": "F", "Timeframe": "B", "IndustryCode": "Other", "LeadGrade": "N/A", "Rep": "", "FollowUp": "", "LeadNotes": "", "DeviceId": "308E9CA1-9906-41A4-B3AE-4A487A72F71A", "OriginalScan": "2025-11-26 13:12:21.580" },
    //    //    { "AppLeadID": 3, "FName": "ODDIE", "LName": "LEOPANDO", "Company": "FORTIS MECHANICAL PRODUCTS CO", "Title": "CEO", "Email": "OLEOPANDO@FORTISMECHANICAL.COM", "Phone": "717-669-4815", "Address": "980 WOODRIDGE BLVD", "City": "LANCASTER", "State": "PA", "Zip": "17601", "PurchasingRole": "F", "Timeframe": "D", "IndustryCode": "Custom Metal Parts", "LeadGrade": "N/A", "Rep": "", "FollowUp": "", "LeadNotes": "", "DeviceId": "308E9CA1-9906-41A4-B3AE-4A487A72F71A", "OriginalScan": "2025-11-26 13:12:38.250" },
    //    //    { "AppLeadID": 4, "FName": "JEREMY", "LName": "KEY", "Company": "ALUMINUM ALLOYS", "Title": "PROD MGR", "Email": "JKEY@ALUMINUMALLOYSINC.COM", "Phone": "610-678-8023", "Address": "4601 PENN AVE", "City": "SINKING SPRING", "State": "PA", "Zip": "19608", "PurchasingRole": "F", "Timeframe": "A", "IndustryCode": "Custom Metal Parts", "LeadGrade": "N/A", "Rep": "", "FollowUp": "", "LeadNotes": "", "DeviceId": "308E9CA1-9906-41A4-B3AE-4A487A72F71A", "OriginalScan": "2025-11-26 13:13:42.840" },
    //    //    { "AppLeadID": 5, "FName": "JOHN", "LName": "BENTZ", "Company": "JAMES SPRING & WIRE CO", "Title": "MAINT TECH", "Email": "TOOLROOM@JAMESSPRIN.COM", "Phone": "610-644-3450", "Address": "6 N BACTON HILL RD", "City": "MALVERN", "State": "PA", "Zip": "19355", "PurchasingRole": "R", "Timeframe": "E", "IndustryCode": "Custom Metal Parts", "LeadGrade": "N/A", "Rep": "", "FollowUp": "", "LeadNotes": "", "DeviceId": "308E9CA1-9906-41A4-B3AE-4A487A72F71A", "OriginalScan": "2025-11-26 13:13:49.794" },
    //    //    { "AppLeadID": 6, "FName": "CHRIS", "LName": "LAUCELLA", "Company": "GWYNEDD MANUFACTURING", "Title": "DIR", "Email": "C.LAUCELLA@GWYNEDDMFG.COM", "Phone": "610-272-2060", "Address": "800 N WALES RD", "City": "NORTH WALES", "State": "PA", "Zip": "19454", "PurchasingRole": "F", "Timeframe": "A", "IndustryCode": "Sporting Goods", "LeadGrade": "N/A", "Rep": "", "FollowUp": "", "LeadNotes": "", "DeviceId": "308E9CA1-9906-41A4-B3AE-4A487A72F71A", "OriginalScan": "2025-11-26 13:13:54.760" },
    //    //    { "AppLeadID": 7, "FName": "Gary", "LName": "Boigon", "Company": "S & W METAL PRODUCTS ", "Title": "Business Development", "Email": "gboigon@swmetalproducts.com", "Phone": "6104732400", "Address": "441 County Line Road", "City": "GILBERTSVILLE", "State": "PA", "Zip": "19525", "PurchasingRole": "", "Timeframe": "", "IndustryCode": "N/A", "LeadGrade": "N/A", "Rep": "", "FollowUp": "", "LeadNotes": "", "DeviceId": "308E9CA1-9906-41A4-B3AE-4A487A72F71A", "OriginalScan": "2025-11-26 13:14:05.148" },
    //    //    { "AppLeadID": 8, "FName": "GARY", "LName": "MCKINNEY", "Company": "OFF SITE MANUFACTURING", "Title": "VP", "Email": "GMCKINNEY@OFFSITEMFG.COM", "Phone": "810-459-6923", "Address": "50350 E RUSSEL SCHMIDT", "City": "CHESTERFIELD TOWNSHIP", "State": "MI", "Zip": "48051", "PurchasingRole": "F", "Timeframe": "D", "IndustryCode": "Machinery", "LeadGrade": "N/A", "Rep": "", "FollowUp": "", "LeadNotes": "", "DeviceId": "308E9CA1-9906-41A4-B3AE-4A487A72F71A", "OriginalScan": "2025-11-26 13:14:09.574" },
    //    //    { "AppLeadID": 9, "FName": "SARVA", "LName": "KOMPELLA", "Company": "PRINTED SOLID", "Title": "MFG OPS MGR", "Email": "SARVA@PRINTEDSOLID.COM", "Phone": "302-204-1306", "Address": "1 CROWELL RD", "City": "WILMINGTON", "State": "DE", "Zip": "19804", "PurchasingRole": "S", "Timeframe": "B", "IndustryCode": "Other", "LeadGrade": "N/A", "Rep": "", "FollowUp": "", "LeadNotes": "", "DeviceId": "308E9CA1-9906-41A4-B3AE-4A487A72F71A", "OriginalScan": "2025-11-26 13:14:32.128" },
    //    //    { "AppLeadID": 10, "FName": "MATT", "LName": "MICKEN", "Company": "DIXON", "Title": "AME MANAGER", "Email": "MMICKEN@DIXONVALVE.COM", "Phone": "410-788-2000", "Address": "153 DIXON DRIVE", "City": "CHESTERTOWN", "State": "MD", "Zip": "21620", "PurchasingRole": "S", "Timeframe": "B", "IndustryCode": "Energy/Utilities", "LeadGrade": "N/A", "Rep": "", "FollowUp": "", "LeadNotes": "", "DeviceId": "308E9CA1-9906-41A4-B3AE-4A487A72F71A", "OriginalScan": "2025-11-26 13:14:37.482" },
    //    //    { "AppLeadID": 11, "FName": "ZACHARY", "LName": "JENKINS", "Company": "CLARK ASSOCIATES", "Title": "SR PRODUCT ENGR", "Email": "ZJENKINS@CLARKINC.BIZ", "Phone": "215-359-5339", "Address": "2551 HORSESHOE RD", "City": "LANCASTER", "State": "PA", "Zip": "17602", "PurchasingRole": "R", "Timeframe": "D", "IndustryCode": "Other", "LeadGrade": "N/A", "Rep": "", "FollowUp": "", "LeadNotes": "", "DeviceId": "308E9CA1-9906-41A4-B3AE-4A487A72F71A", "OriginalScan": "2025-11-26 13:14:40.863" }]

    //    //let myLeads = [{ "AppLeadID": 2, "FName": "DENNIS", "LName": "MURPHY", "Company": "CMB USA HV INDUSTRIES", "Title": "PLANT MGR", "Email": "DENNIS.MURPHY@CMBE.COM", "Phone": "215-322-3527", "Address": "3100 TREMONT", "City": "FEASTERVILLE", "State": "PA", "Zip": "18901", "PurchasingRole": "F", "Timeframe": "B", "IndustryCode": "Other", "LeadGrade": "N/A", "Rep": "", "FollowUp": "", "LeadNotes": "", "DeviceId": "308E9CA1-9906-41A4-B3AE-4A487A72F71A", "OriginalScan": "2025-11-26 13:12:21.580" },
    //    //{ "AppLeadID": 3, "FName": "ODDIE", "LName": "LEOPANDO", "Company": "FORTIS MECHANICAL PRODUCTS CO", "Title": "CEO", "Email": "OLEOPANDO@FORTISMECHANICAL.COM", "Phone": "717-669-4815", "Address": "980 WOODRIDGE BLVD", "City": "LANCASTER", "State": "PA", "Zip": "17601", "PurchasingRole": "F", "Timeframe": "D", "IndustryCode": "Custom Metal Parts", "LeadGrade": "N/A", "Rep": "", "FollowUp": "", "LeadNotes": "", "DeviceId": "308E9CA1-9906-41A4-B3AE-4A487A72F71A", "OriginalScan": "2025-11-26 13:12:38.250" },
    //    //{ "AppLeadID": 4, "FName": "JEREMY", "LName": "KEY", "Company": "ALUMINUM ALLOYS", "Title": "PROD MGR", "Email": "JKEY@ALUMINUMALLOYSINC.COM", "Phone": "610-678-8023", "Address": "4601 PENN AVE", "City": "SINKING SPRING", "State": "PA", "Zip": "19608", "PurchasingRole": "F", "Timeframe": "A", "IndustryCode": "Custom Metal Parts", "LeadGrade": "N/A", "Rep": "", "FollowUp": "", "LeadNotes": "", "DeviceId": "308E9CA1-9906-41A4-B3AE-4A487A72F71A", "OriginalScan": "2025-11-26 13:13:42.840" },
    //    //{ "AppLeadID": 6, "FName": "CHRIS", "LName": "LAUCELLA", "Company": "GWYNEDD MANUFACTURING", "Title": "DIR", "Email": "C.LAUCELLA@GWYNEDDMFG.COM", "Phone": "610-272-2060", "Address": "800 N WALES RD", "City": "NORTH WALES", "State": "PA", "Zip": "19454", "PurchasingRole": "F", "Timeframe": "A", "IndustryCode": "Sporting Goods", "LeadGrade": "N/A", "Rep": "", "FollowUp": "", "LeadNotes": "", "DeviceId": "308E9CA1-9906-41A4-B3AE-4A487A72F71A", "OriginalScan": "2025-11-26 13:13:54.760" }]

    //    const myJSON = JSON.stringify(myLeads);

    //    let postdata = {
    //        apiKey: 'D2P@16W@t3rburY',
    //        exhibitorid: 3547,
    //        showcode: 403,
    //        leads: myJSON
    //    };

    //    Axios.post(`/api/PostLeadsToD2P`, postdata
    //    ).then(response => {
    //        if (response.data.includes('Success')) {
    //            toast.success('Leads Successfully Processed');
    //        }
    //        else {
    //            toast.error('Error Processing Leads');
    //        }
    //    }).catch(error => {
    //        console.log(error);
    //    });
    //}

    return (
        <div>
            <h3>New API Endpoint Tester</h3>
            <div className="row">
                <div className="col col-12">
                    Uncomment the buttons and API Endpoint calls to test the new D2P API endpoints.
                </div>

                {/*<div className="col col-12">*/}
                {/*    <button type="button" class="btn btn-link" onClick={handleVerifyAPIKey}>VerifyAPIKey</button>*/}
                {/*</div>*/}
                {/*<div className="col col-12">*/}
                {/*    <button type="button" class="btn btn-link" onClick={handleGetActiveShowsForD2PApp}>GetActiveShowsForD2PApp</button>*/}
                {/*</div>*/}
                {/*<div className="col col-12">*/}
                {/*    <button type="button" class="btn btn-link" onClick={handleGetAppControlInfo}>GetAppControlInfo</button>*/}
                {/*</div>*/}
                {/*<div className="col col-12">*/}
                {/*    <button type="button" class="btn btn-link" onClick={handleRegisterExhibitor}>RegisterExhibitor</button>*/}
                {/*</div>*/}
                {/*<div className="col col-12">*/}
                {/*    <button type="button" class="btn btn-link" onClick={handleValidateExhibitor}>ValidateExhibitor</button>*/}
                {/*</div>*/}
                {/*<div className="col col-12">*/}
                {/*    <button type="button" class="btn btn-link" onClick={handleGetHallImageFileFromDB}>GetHallImageFileFromDB</button>*/}
                {/*</div>*/}
                {/*<div className="col col-12">*/}
                {/*    <button type="button" class="btn btn-link" onClick={handleProcessLeadsToD2P}>ProcessLeadsToD2P</button>*/}
                {/*</div>*/}
            </div>
        </div>
    );
}

export default withRouter(NewApiTester);